const Admin = (props) => {
    const { map } = props;

    const refineLocation = () => {
        if (map) {
            const { lat: currLat, lng: currLng } = map.getCenter();
            const currZoom = map.getZoom();
            window.history.replaceState(
                null,
                null,
                `${window.location.href.split('?')[0]}?lat=${currLat}&lng=${currLng}&zoom=${currZoom}`
            );
        }
    };

    setInterval(() => refineLocation(), 500);

    return <></>;
};

export default Admin;
